import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {useRouter} from 'next/router';

// Will be replaced with the internal link to the dedicated feature when ready
const FALLBACK_CTA_LINKS: {default: string; fr: string} = {
	default:
		'https://newsroom-deezer.com/2025/11/deezer-now-lets-you-choose-the-look-and-the-layout-of-the-app-for-a-more-tailored-experience/',
	fr: 'https://newsroom-deezer.com/fr/2025/11/deezer-personnalisation-interface-application/',
};

export const CustoSection: FunctionComponent = () => {
	const {locale} = useRouter();
	const {t} = useTranslation();
	const ctaLink =
		locale === 'fr' ? FALLBACK_CTA_LINKS.fr : FALLBACK_CTA_LINKS.default;

	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading
						as="h2"
						dangerouslySetInnerHTML={{
							__html: t(
								'featureslandingpage_title_musicthatsmoreu_standalone-web',
								{ns: 'features'},
							),
						}}
					/>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_discoverapptunedtourtastes_standalone-web',
							{ns: 'features'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					h={{base: '250px', md: '100%'}}
					alt={'custo'}
					quality={90}
					objectFit={{base: 'cover', sm: 'contain'}}
					aspectRatio="1860/824"
					src={'65225ed3c67d5b1eeca22427678c743f.png'}
					width={{base: '100%', md: '70%'}}
					height={{base: '90%', md: '100%'}}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'custo'}}
					href={ctaLink}
				>
					{t('generic_action_findoutmore_standalone-features', {
						ns: 'features',
					})}
				</LandingButtonLink>
			}
		/>
	);
};
